import { Component, OnInit } from '@angular/core';
import { Mandate } from '@dch/products-business-logic';
import { MpayService } from '../../../services/mpay.service';
import { AlertsService } from '@proximus/ng-common-components';
import { Store } from '@ngrx/store';
import { ApplicationState, getMandateDeleted } from '../../../store/reducers';
import {
  ClearDeleteMandateFlag,
  DeleteMandate,
} from '../../../store/actions/product-details.actions';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-delete-mandate',
  templateUrl: './delete-mandate.component.html',
})
export class DeleteMandateComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public mandate: Mandate;
  destroy: () => void;
  accessNumber: string;
  mpcUuid: string;
  buttonsDisabled: boolean;

  constructor(
    private mpayService: MpayService,
    private alertService: AlertsService,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  close() {
    this.destroy();
  }

  confirm() {
    this.store.dispatch(
      new DeleteMandate({
        mandate: this.mandate,
        accessNumber: this.accessNumber,
        mpcUuid: this.mpcUuid,
      }),
    );
    this.buttonsDisabled = true;
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store.select(getMandateDeleted).subscribe((mandateDeleted) => {
        if (mandateDeleted != null) {
          if (mandateDeleted) {
            this.alertService.dispatchAlert({
              isClosable: true,
              alertKey: this.mpcUuid + 'alertLevel3',
              title: this.translationService.getTranslatedValueFor(
                'mpay.threshold.mandate.delete.success.title',
              ),
              description: this.translationService.getTranslatedValueFor(
                'mpay.threshold.mandate.delete.success.description',
              ),
              type: 'success',
            });
          } else if (!mandateDeleted) {
            this.alertService.dispatchAlert({
              isClosable: true,
              alertKey: this.mpcUuid + 'alertLevel3',
              title: this.translationService.getTranslatedValueFor(
                'mpay.threshold.mandate.delete.error.title',
              ),
              description: this.translationService.getTranslatedValueFor(
                'mpay.threshold.mandate.delete.error.description',
              ),
              type: 'error',
            });
          }
          this.store.dispatch(new ClearDeleteMandateFlag());
          this.close();
        }
      }),
    );
  }
}
